const features = [
  {
    icon: "ri-close-circle-line",
    title: "无广告纯净阅读",
    desc: "会员阅读全程无任何横幅、弹窗与贴片广告，章节翻页流畅无打断，还你一个纯粹的沉浸式阅读空间。",
  },
  {
    icon: "ri-4k-line",
    title: "尊享高画质原版",
    desc: "提供高画质原版漫画资源，画面线条细腻、色彩还原真实，尊享 4K 高清质感，最大程度贴近原作体验。",
  },
  {
    icon: "ri-time-line",
    title: "VIP 章节抢先看",
    desc: "最新上线的原版章节面向会员优先解锁，土豪专属内容先人一步看到，永远快人一步，不错过任何精彩。",
  },
  {
    icon: "ri-device-line",
    title: "多端同步追漫",
    desc: "电脑、平板、手机跨端登录，阅读进度与已解锁章节实时同步，随时随地接着看，追更订阅提醒贴心送达。",
  },
];

export default function VipFeatures() {
  return (
    <section id="vip" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 md:mb-14 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
              <i className="ri-vip-diamond-line"></i>
              尊享会员权益
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              为什么选择<span className="text-gradient-gold">土豪会员</span>
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-400">
            从阅读体验、画质资源到更新速度，土豪会员把每一次阅读都变成享受，只为你提供真正的尊享服务。
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {features.map((f, i) => (
            <article
              key={f.title}
              className={`glow-card rounded-lg border border-background-600/60 bg-background-900/60 p-5 transition-transform duration-300 hover:-translate-y-1 md:p-6 ${i === 3 ? "lg:bg-background-800/70" : ""}`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500/15 text-2xl text-primary-400">
                <i className={f.icon}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-50">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-400">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}